import React, { Component } from 'react'
import { connect } from 'react-redux'

import Divider from 'material-ui/Divider'

import Events from './events'
import Comments from 'components/Comments'
import Attachments from 'components/Attachments'
import FormFooter from 'components/FormFooter'

import { attachmentPath } from 'selectors/attachments'

let select = (state, props) => ({
	path: attachmentPath(state, props.propertyID)
})

export class RightSide extends Component{
	render(){
		let { props } = this
		let oneColumn = this.props.colspan == 1
		return(
			<div className="rightSide"
				style={{
					width: (this.props.colspan>1)?"50%":"100%"
				  , clear:"both"
				  , position: "relative"
				  , display: "block"
				  , overflowY: (this.props.colspan>1)?"scroll":"auto"
				}}
			>
				<div className="wrapper"
					style={{
						paddingBottom: "70px"
					  , overflow:"hidden"
					  , minHeight: !oneColumn?"calc(100vh - 64px)":"0"
					  , borderLeft: !oneColumn? "1px solid rgba(0,0,0,0.3)" : "none"
					}}
				>
					<Attachments top={!oneColumn} objectID={this.props.propertyID} path={props.path} removable={true}/>
					<Comments objectID={this.props.propertyID} path={props.path} />
					<Events propertyID={this.props.propertyID} />
				</div>


			</div>
		)
	}
}

export default connect(select)(RightSide)



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/RightSide.js